const language = {
	spanish: {
		title: "Tutoriales Foresight GPS",
		tutorial_1_title: "Instalación",
		tutorial_2_title: "Tracking GPS",
		tutorial_3_title: "Seguridad",
		tutorial_4_title: "Sistemas GPS",
		tutorial_default_content:
			"Puede configurar y personalizar su software según las necesidades de su negocio para una gestión más eficaz y rápida.",
		link_text: "Descargar Tutorial",
	},
	english: {
		title: "Foresight GPS Tutorials",
		tutorial_1_title: "Installation",
		tutorial_2_title: "Tracking GPS",
		tutorial_3_title: "Security",
		tutorial_4_title: "GPS Systems",
		tutorial_default_content:
			"You can configure and customize your software according to your business needs for more efficient and faster management.",
		link_text: "Download Tutorial",
	},
};

export default language